import { dev } from '$app/environment'
import { getLocale } from '$lib/paraglide/runtime'
import type { PageLoad } from './$types'
import { asError } from '$lib/utils'

export const load: PageLoad = async ({ params: { slug }, depends, data: serverData }) => {
	depends('paraglide:lang')
	try {
		const locale = getLocale()
		const { default: content, metadata: meta = {} } = await importMarkdown(locale, slug)

		return {
			...serverData,
			content,
			meta,
			slug
		}
	} catch {
		throw asError(404, `Could not find ${slug}`)
	}
}

async function importMarkdown(locale: string, slug: string) {
	// For English (source language), import directly from source
	if (locale === 'en') {
		return await import(`../../posts/${slug}.md`)
	} else {
		try {
			return await import(`../../../l10n-cage/md/${locale}/${slug}.md`)
		} catch (error) {
			if (dev) {
				return {
					default: `## Couldn't import translation!\n(This is only tolerated in development mode.)`
				}
			}
			throw error
		}
	}
}
